/**
 * BrandTicker — "AUTHORISED STOCKIST FOR:" scrolling marquee banner.
 * Maps to the Brand Trust Banner section in index.html.
 * Design tokens: ds-primary (separator), ds-on-background (text), ds-surface-container-lowest (bg).
 *
 * Props:
 *   brands: string[] — list of brand names to display. Passed from parent
 *   so this component stays pure/testable.
 */
import React from "react";

const SEPARATOR = (
  <span className="text-ds-primary mx-5 select-none" aria-hidden="true">
    |
  </span>
);

const BrandTicker = ({ brands = [] }) => {
  if (brands.length === 0) return null;

  // Duplicate the list to create a seamless infinite loop
  const items = [...brands, ...brands];

  return (
    <div className="border-y border-ds-outline-variant/30 bg-ds-surface-container-lowest overflow-hidden py-3">
      <div className="flex items-center max-w-[1280px] mx-auto px-10">
        <span className="font-inter font-semibold text-[11px] tracking-[0.08em] uppercase text-ds-secondary whitespace-nowrap mr-6 shrink-0">
          AUTHORISED STOCKIST FOR:
        </span>

        {/* Marquee container */}
        <div className="overflow-hidden flex-1">
          <div
            className="inline-flex items-center whitespace-nowrap"
            style={{ animation: "ds-marquee 30s linear infinite" }}
            aria-label="Authorised brands list"
          >
            {items.map((brand, idx) => (
              <React.Fragment key={`${brand}-${idx}`}>
                <span className="font-barlow font-bold text-[20px] text-ds-on-background">
                  {brand}
                </span>
                {idx < items.length - 1 && SEPARATOR}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      {/* Keyframe injected inline — avoids adding to global CSS */}
      <style>{`
        @keyframes ds-marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};

export default BrandTicker;
